import { useFastshiftSelector } from "../../../../state/hook";

const CONSOLIDATED_INSIGHTS_STATUS_HAS_ERRORS = "HAS_ERRORS";

export const useSummary = () => {
    const { l1Assessments, migrationPlanTotals, instances, selectedDomainOrg } =
        useFastshiftSelector((state) => ({
            l1Assessments: state.l1Assessments,
            migrationPlanTotals: state.migrationPlanTotals,
            instances: state.instances,
            selectedDomainOrg: state.selectedDomainOrg
        }));

    const isLoading =
        l1Assessments.pending ||
        migrationPlanTotals.pending ||
        instances.pending ||
        !selectedDomainOrg;

    const summaryData = {
        dataCenter: {
            count: l1Assessments.data.length
        },
        areaImprovement: {
            count: l1Assessments.data.filter(
                ({ consolidatedInsightsStatus }) =>
                    consolidatedInsightsStatus ===
                    CONSOLIDATED_INSIGHTS_STATUS_HAS_ERRORS
            ).length
        },
        deletedApps: {
            count: instances.data.totalCount
        },
        migrationCompleted: {
            count: migrationPlanTotals.data.totalPlansCompleted
        },
        migrationInProgress: {
            count: migrationPlanTotals.data.totalPlansRunning
        },
        unsuccessfulMigration: {
            count: migrationPlanTotals.data.totalPlansUnsuccessful
        }
    };

    // isEmpty means there is no data and no errors and not loading
    const isEmpty =
        l1Assessments.data.length === 0 &&
        instances.data.totalCount === 0 &&
        migrationPlanTotals.data.totalPlansCompleted === 0 &&
        migrationPlanTotals.data.totalPlansUnsuccessful === 0 &&
        migrationPlanTotals.data.totalPlansRunning === 0 &&
        !isLoading &&
        !l1Assessments.error &&
        !instances.error &&
        !migrationPlanTotals.error;

    const errors = {
        l1Assessments: l1Assessments.error,
        migrationPlanTotals: migrationPlanTotals.error,
        instances: instances.error
    };

    return { summaryData, isLoading, isEmpty, errors };
};
